<template>
  <RouterView class="view"/>
  <!-- <ProductsGrid v-if="productData" :products="productData" /> -->
</template>

<script>
import { RouterView } from 'vue-router';
export default {
  name: 'App',
  components: {
    RouterView,
  }
 
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html, body, #app {
  height: 100%;
  margin: 0;
display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;
}

.view {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
